/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `Toto pole je povinné`
};

const da_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `Dette felt er påkrævet`
};

const de_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `Dieses Feld ist erforderlich`
};

const en_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `This field is required`
};

const es_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `Este campo es obligatorio`
};

const fr_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `Ce champ est requis`
};

const hu_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `Ez a mező kötelező`
};

const it_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `Questo campo è obbligatorio`
};

const nl_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `Dit veld is verplicht`
};

const pl_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `To pole jest wymagane`
};

const pt_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `Este campo é obrigatório`
};

const sv_this_field_is_required = /** @type {(inputs: {}) => string} */ () => {
	return `Detta fält är obligatoriskt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const this_field_is_required = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.this_field_is_required(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("this_field_is_required", locale)
	if (locale === "cs") return cs_this_field_is_required(inputs)
	if (locale === "da") return da_this_field_is_required(inputs)
	if (locale === "de") return de_this_field_is_required(inputs)
	if (locale === "en") return en_this_field_is_required(inputs)
	if (locale === "es") return es_this_field_is_required(inputs)
	if (locale === "fr") return fr_this_field_is_required(inputs)
	if (locale === "hu") return hu_this_field_is_required(inputs)
	if (locale === "it") return it_this_field_is_required(inputs)
	if (locale === "nl") return nl_this_field_is_required(inputs)
	if (locale === "pl") return pl_this_field_is_required(inputs)
	if (locale === "pt") return pt_this_field_is_required(inputs)
	return sv_this_field_is_required(inputs)
};